const SET_WORKSPACE_CONNECTED = (state, payload) => {
  state.workspace.connected = payload
}

export { SET_WORKSPACE_CONNECTED }
